import { type ReactNode, useState, forwardRef, type ForwardedRef } from 'react';
import { type AlertProps as MuiAlertProps, AlertTitle, Alert as MuiAlert, styled } from '@mui/material';

const MuiAlertWithForwardedRef = forwardRef((props : AlertProps, ref : ForwardedRef<HTMLDivElement>) => <MuiAlert ref={ref} {...props} />);

MuiAlertWithForwardedRef.displayName = 'MuiAlertWithForwardedRef';

const MuiAlertWithSystem = styled(MuiAlertWithForwardedRef)``;

export type AlertProps = MuiAlertProps & {
  closable?: boolean;
  title?: ReactNode;
};

export const Alert = forwardRef(({title, children, closable = false, ...props} : AlertProps, ref : ForwardedRef<HTMLDivElement>): JSX.Element => {
  const [open, setOpen] = useState(true);

  const handleClose = () => setOpen(false);

  if (!open) return null;

  return (
    <MuiAlertWithSystem ref={ref} onClose={closable ? handleClose : undefined} sx={{mt: 2}} {...props}>
      {title && <AlertTitle>{title}</AlertTitle>}
      {children}
    </MuiAlertWithSystem>
  );
});

Alert.displayName = 'Alert';

export default Alert;